
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from "moment";

export const RoadEstimateExportData = (props) => {
    const { ExcelData, name, searchName } = props
    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />
            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '100%' }}>

                <h5><span>&emsp;</span></h5>

                <h4 style={{ textAlign: 'center', fontSize: 16 }}>{name}</h4>

                <tr><td></td></tr>

                <thead className="thead-dark" >
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white' }}>
                        <th>Sr.No.</th>
                        <th>Location Name</th>
                        <th>Work Area</th>
                        <th>Work Name</th>
                        <th>Work Number</th>
                        <th>Before Photo Date</th>                     
                        <th>After Photo Date</th>                     
                        <th>Estimated Amount (Rs.)</th>

                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((item, i) => (
                            <tr style={{ textAlign: "center" }}>
                                <td >{item.rowNum}</td>

                                <td>{item.locationName ? item.locationName : '-'}</td>
                                <td>{item.workArea ? item.workArea : '-'}</td>
                                <td>{item.workName ? item.workName : '-'}</td>
                                <td>{item.workNumber ? item.workNumber : '-'}</td>
                                <td>{item.workUploadDate ? moment(item.workUploadDate).format("DD-MM-YYYY") : '-'}</td>
                                <td>{item.doneDate ? moment(item.doneDate).format("DD-MM-YYYY") : '-'}</td>
                                <td>{item.estimatedAmount ? item.estimatedAmount.toFixed(2) : '-'}</td>
                            </tr>
                        ))

                            : <tr>No data</tr>
                    }
                </tbody>
            </table>
        </div>
    )
}